import { Component, OnInit, HostListener, ElementRef } from '@angular/core';

import { OomphComponent } from '../oomph.component';

@Component({
  selector: 'sn-oom-payments',
  templateUrl: './oom-payments.component.html',
  styleUrls: ['./oom-payments.component.css']
})
export class OomPaymentsComponent extends OomphComponent {

  public scrollHeight:number;
  private screenScale:number = 0.992;

  public new_users: Object[];
  public existing_users: Object[];
  private tableOffset: number = -110;

  ngOnInit() {
    this.oomphService.setCurrentView(this.oomphService.view_oom_payments);
    this.currentScreenSize.subscribe((size) => {
      this.scrollHeight = (size.height + this.tableOffset);
    })
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/oomph/oom-payments/oom-payments.component.ts